/*
 * @Author: your name
 * @Date: 2022-10-28 09:45:04
 * @LastEditTime: 2022-11-17 11:02:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/EnvManage/HostMonitor/BaseFormModal.tsx
 */

import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useIntl } from 'react-intl';

// 固定的渲染组件
const customCmpMap: any = {
  text: Input,
  textarea: Input.TextArea,
  password: Input.Password,
};

export default function createBaseForm(options: any) {
  const { formProps } = options; // 给form.create()的参数

  return (fields: any) => {
    const BaseFormModal = forwardRef<FormComponentProps>((props: any, ref: React.Ref<unknown> | undefined) => {
      const intl = useIntl();

      // 返回固定组件
      const renderCustomCmp = (type: string, formItemProps: any) => {
        const Component = customCmpMap[type];
        return <Component {...formItemProps} />;
      };

      // 转发form
      useImperativeHandle(ref, () => {
        return {
          form,
        };
      });

      const { initData = {}, form, compData, labelCol, wrapperCol, ...restProps } = props;

      const { getFieldDecorator } = form;
      // FIXME optimize unnecessary execute
      const intlFields = fields({ fmt: intl.formatMessage, form, ...restProps });
      return (
        <Form layout="horizontal" labelCol={labelCol} wrapperCol={wrapperCol}>
          {intlFields.map((field: any) => {
            const { key, label, renderFormItem, rules = [], type, formItemProps = {}, ...restProps } = field;

            const formatedRules = rules.map((rule: any) => {
              return typeof rule === 'function' ? rule(form) : rule;
            });

            return (
              <Form.Item label={label} key={key} {...restProps}>
                {getFieldDecorator(key, {
                  initialValue: initData[key],
                  rules: formatedRules,
                })(renderFormItem ? renderFormItem(compData) : renderCustomCmp(type, formItemProps))}
              </Form.Item>
            );
          })}
        </Form>
      );
    });

    return Form.create({ ...formProps })(BaseFormModal);
  };
}
